import { CheckIcon } from '@heroicons/react/20/solid';
import { ListboxOption } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { DropdownOptionType, DropdownSize } from '../types';
import { dropdownClasses } from '../styles';
import { classNames } from 'support/helpers/generic/generic';

type DropdownOptionsProps<TValue> = {
  options: Array<DropdownOptionType<TValue>>;
  size: DropdownSize;
};

export function DropdownOptions<TValue>({ options, size }: DropdownOptionsProps<TValue>) {
  const { t } = useTranslation();

  return (
    <>
      {options.map((option) => (
        <ListboxOption
          as="li"
          key={String(option.value)}
          className={({ focus, disabled }) =>
            classNames(
              focus ? 'bg-procuros-green-500' : '',
              'ml-0 cursor-default select-none relative py-2 px-2',
              disabled ? 'text-gray-500' : 'text-black',
              dropdownClasses.listItem.size[size],
            )
          }
          value={option.value}
          disabled={option.disabled}
          data-testid={option.testId}
        >
          {({ selected, focus }) => (
            <span className="flex justify-between gap-2">
              <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                {t(option.label)}
              </span>

              {selected ? (
                <span className={classNames(focus ? 'text-white' : 'text-procuros-green-600', 'flex items-center')}>
                  <CheckIcon className="size-4" aria-hidden="true" />
                </span>
              ) : null}
            </span>
          )}
        </ListboxOption>
      ))}
    </>
  );
}
